﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';

import Valg from '../Shared/Scripts/Models/Valg';

import VeilederUtstyrsstipendDto from './Models/VeilederUtstyrsstipendDto';

import * as Ids from './Models/Ids';

import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';

import AUtdanningsValg from './Utilities/A-Utdanningsvalg';
import BStudieforberedendeValg from './Utilities/B-Studieforberedende';
import BYrkesfagValg from './Utilities/B-Yrkesfag';
import { CaValg, CbValg, CcValg, CdValg, CeValg } from './Utilities/C-Aar';
import { DaValg, DbValg, DcValg, DdValg, DdVg3Valg, DeValg } from './Utilities/D-Program';

import EaResultatComponent from './Components/EaResultatComponent';
import EbResultatComponent from './Components/EbResultatComponent';
import EcResultatComponent from './Components/EcResultatComponent';
import EdResultatComponent from './Components/EdResultatComponent';
import EeResultatComponent from './Components/EeResultatComponent';

import UtbetalingComponent from './Components/UtbetalingComponent';

import { ResultatValg } from './Store/Resultat/Types';

import { VeilederUtstyrsstipendAppState } from './Store/index';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}
type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederUtstyrsstipendDto>();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }
    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel } = this.props.epiContext;

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aUtdanningsValg != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (
                    resultat.visUtstyrsstipendEa ||
                    resultat.visUtstyrsstipendEb ||
                    resultat.visUtstyrsstipendEc ||
                    resultat.visUtstyrsstipendEd ||
                    resultat.visUtstyrsstipendEe
                ) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }
        if (epiModel != null) {
            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelA')}
                        forklaring={contentResolver(epiContext, 'infotekstA')}
                        sporsmal="sporsmalA"
                        valg={AUtdanningsValg.aValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aUtdanningsValg: nyttValg });
                        }}
                        neverCollapse={true}
                        classModifier="c-veileder__panel--input-white"
                        value={valg.aUtdanningsValg}
                    />
                    {resultat.visStudieforberedendeBa && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksBa}
                            tittel={contentResolver(epiContext, 'tittelBa')}
                            forklaring={contentResolver(epiContext, 'infotekstBa')}
                            sporsmal="sporsmalBa"
                            valg={BStudieforberedendeValg.baValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({
                                    bStudieforberedende: nyttValg,
                                    bYrkesfag: undefined,
                                    cAar: undefined,
                                    dProgram: undefined,
                                });
                            }}
                            value={valg.bStudieforberedende}
                        />
                    )}
                    {resultat.visYrkesfagBb && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksBa}
                            tittel={contentResolver(epiContext, 'tittelBb')}
                            forklaring={contentResolver(epiContext, 'infotekstBb')}
                            sporsmal="sporsmalBb"
                            valg={BYrkesfagValg.bbValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({
                                    bYrkesfag: nyttValg,
                                    bStudieforberedende: undefined,
                                    cAar: undefined,
                                    dProgram: undefined,
                                });
                            }}
                            value={valg.bYrkesfag}
                        />
                    )}
                    {resultat.visAarCa && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksCa}
                            tittel={contentResolver(epiContext, 'tittelAarC')}
                            forklaring={contentResolver(epiContext, 'infotekstAarC')}
                            sporsmal="sporsmalAarC"
                            valg={CaValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cAar: nyttValg, dProgram: undefined });
                            }}
                            value={valg.cAar}
                        />
                    )}
                    {resultat.visAarCb && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksCb}
                            tittel={contentResolver(epiContext, 'tittelAarC')}
                            forklaring={contentResolver(epiContext, 'infotekstAarC')}
                            sporsmal="sporsmalAarC"
                            valg={CbValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cAar: nyttValg, dProgram: undefined });
                            }}
                            value={valg.cAar}
                        />
                    )}
                    {resultat.visAarCc && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksCc}
                            tittel={contentResolver(epiContext, 'tittelAarC')}
                            forklaring={contentResolver(epiContext, 'infotekstAarC')}
                            sporsmal="sporsmalAarC"
                            valg={CcValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cAar: nyttValg, dProgram: undefined });
                            }}
                            value={valg.cAar}
                        />
                    )}
                    {resultat.visAarCd && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksCd}
                            tittel={contentResolver(epiContext, 'tittelAarC')}
                            forklaring={contentResolver(epiContext, 'infotekstAarC')}
                            sporsmal="sporsmalAarC"
                            valg={CdValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cAar: nyttValg, dProgram: undefined });
                            }}
                            value={valg.cAar}
                        />
                    )}
                    {resultat.visAarCe && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksCe}
                            tittel={contentResolver(epiContext, 'tittelAarC')}
                            forklaring={contentResolver(epiContext, 'infotekstAarC')}
                            sporsmal="sporsmalAarC"
                            valg={CeValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cAar: nyttValg, dProgram: undefined });
                            }}
                            value={valg.cAar}
                        />
                    )}
                    {resultat.visProgramDa && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDa}
                            tittel={contentResolver(epiContext, 'tittelProgramDa')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDa')}
                            sporsmal="sporsmalProgramDa"
                            valg={DaValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visProgramDb && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDb}
                            tittel={contentResolver(epiContext, 'tittelProgramDb')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDb')}
                            sporsmal="sporsmalProgramDb"
                            valg={DbValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visProgramDc && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDc}
                            tittel={contentResolver(epiContext, 'tittelProgramDc')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDc')}
                            sporsmal="sporsmalProgramDc"
                            valg={DcValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visProgramDd && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDd}
                            tittel={contentResolver(epiContext, 'tittelProgramDd')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDd')}
                            sporsmal="sporsmalProgramDd"
                            valg={DdValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visProgramDdVg3 && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDdVg3}
                            tittel={contentResolver(epiContext, 'tittelProgramDdVg3')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDdVg3')}
                            sporsmal="sporsmalProgramDdVg3"
                            valg={DdVg3Valg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visProgramDe && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksDe}
                            tittel={contentResolver(epiContext, 'tittelProgramDe')}
                            forklaring={contentResolver(epiContext, 'infotekstProgramDe')}
                            sporsmal="sporsmalProgramDe"
                            valg={DeValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ dProgram: nyttValg });
                            }}
                            value={valg.dProgram}
                        />
                    )}
                    {resultat.visUtstyrsstipendEa && <EaResultatComponent eventId={eventId} />}
                    {resultat.visUtstyrsstipendEb && <EbResultatComponent eventId={eventId} />}
                    {resultat.visUtstyrsstipendEc && <EcResultatComponent eventId={eventId} />}
                    {resultat.visUtstyrsstipendEd && <EdResultatComponent eventId={eventId} />}
                    {resultat.visUtstyrsstipendEe && <EeResultatComponent eventId={eventId} />}

                    {valg.visUtbetaling && <UtbetalingComponent />}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederUtstyrsstipendDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (nyttValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederUtstyrsstipendAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederUtstyrsstipendAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
